import Axios from 'axios';

class Config {
  constructor() {
    this.config = {};
  }

  async loadConfig() {
    const data = await Axios.get('/config');
    this.config = data.data;
  }

  getValue(property) {
    if (Object.prototype.hasOwnProperty.call(this.config, property)) {
      return this.config[property];
    } else {
      return null;
    }
  }
}

export default new Config();
